
'use strict';

define('lib/podio-ui/config',['require','lib/backbone/Backbone.Mixins.Transport.API','translate','lib/Podio.Config','lib/Podio.Utils'],function (require) {
  var API = require('lib/backbone/Backbone.Mixins.Transport.API');
  var t = require('translate');
  var podioConfig = require('lib/Podio.Config');
  var utils = require('lib/Podio.Utils');

  var config = {
    /**
     * Promise Creators:
     *
     * All async actions, usually those that depend on backend communication, should go here.
     * Input: Arguments that are passed from the component (or other caller) to the given actionCreator.
     * Output: A Promise that will eventually resolve/reject with relevant data/error message.
     *
     * info: https://github.com/podio/podio-ui#promisecreators
    */
    promiseCreators: {
      fetchNotificationGroups: function fetchNotificationGroups(view, limit, offset) {
        var params = { all: '', unread: '&viewed=false', me: '&type=alert' };
        return API.fetch('GET', '/notification?limit=' + limit + '&offset=' + offset + params[view]);
      },
      fetchNotificationUnreadCount: function fetchNotificationUnreadCount() {
        return API.fetch('GET', '/notification/inbox/new/count');
      },
      reconcileNotifications: function reconcileNotifications(fromDate) {
        return API.fetch('GET', '/notification?viewed=false&created_from=' + fromDate);
      },
      markNotificationAsReadByRef: function markNotificationAsReadByRef(type, id) {
        return API.fetch('POST', '/notification/' + type + '/' + id + '/viewed');
      },
      markNotificationAsUnreadByRef: function markNotificationAsUnreadByRef(type, id) {
        return API.fetch('DELETE', '/notification/' + type + '/' + id + '/viewed');
      },
      markAllNotificationsAsRead: function markAllNotificationsAsRead() {
        return API.fetch('POST', '/notification/viewed');
      },
      setItemParticipationStatus: function setItemParticipationStatus(itemId, profileId, status) {
        if (status === 'invited') return Promise.resolve();

        return API.fetch('PUT', '/item/' + itemId + '/participation', { status: status });
      },
      fetchNotificationsViewFilter: function fetchNotificationsViewFilter() {
        return new Promise(function (resolve, reject) {
          API.fetch('GET', '/user/property/notifications_view_filter').then(resolve)
          // If we encounter any errors when fetching this, we default to the 'all' viewFilter
          ['catch'](function () {
            return resolve({ viewFilter: 'all' });
          });
        });
      },
      setNotificationsViewFilter: function setNotificationsViewFilter(viewFilter) {
        return API.fetch('PUT', '/user/property/notifications_view_filter', { viewFilter: viewFilter });
      },
      acceptSpaceMembershipRequest: function acceptSpaceMembershipRequest(spaceId, spaceMemberRequestId) {
        return API.fetch('POST', '/space/' + spaceId + '/member_request/' + spaceMemberRequestId + '/accept');
      }
    },
    /**
     * Constants:
     *
     * Any constants that the components of the UI-kit will consume should be defined here.
     * E.g. this is where we can specify translated versions of user-facing text.
     *
     * info: https://github.com/podio/podio-ui#constants
    */

    constants: {
      env: podioConfig.environment,
      t_ShowAll: t('Show all #app-view'),
      t_Notifications: t('Notifications #notif.dropdown'),
      t_All: t('All'),
      t_Me: t('Me'),
      t_Unread: t('Unread'),
      t_Refresh: t('Refresh'),
      t_ShowMore: t('Show more #new_app_view'),
      t_NoNotifications: t('No new notifications. #notif.dropdown'),
      t_Attending: t('Attending #apps_items_v2'),
      t_NotAttending: t('Not attending #apps_items_v2'),
      t_MaybeAttending: t('Maybe attending #apps_items_v2'),
      t_YouAreAttending: t('You are attending #apps_items_v2'),
      t_YouAreNotAttending: t('You are not attending #apps_items_v2'),
      t_YouAreMaybeAttending: t('You are maybe attending #apps_items_v2'),
      t_Change: t('Change'),
      t_Settings: t('Settings #notif.dropdown'),
      t_GrantAccess: t('Grant access'),
      t_AccessGranted: t('Access granted #notif.dropdown'),
      t_MarkAllAsRead: t('Mark all as read #notif.dropdown'),
      t_MarkAsRead: t('Mark as read #notif.dropdown'),
      t_MarkAsUnread: t('Mark as unread #notif.dropdown'),
      t_TheContextForThisNotificationWasDeleted: t('The context for this notification was deleted #notif.dropdown')
    }
  };

  return config;
});
